import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// API resource: tio-api app/resources/api/v1/approvable_resource.rb
// Registered from the systemic missing-schema audit (the #9130/#8988 class:
// an API-emittable JSON:API type the FE manifest never registered). Mirrors the
// already-registered tas-approvable.schema.ts (the STI subclass); the base
// `approvable` leaks via non-TasApprovable base Approvable records on the
// directly-mounted /approvables collection. The polymorphic belongsTo targets
// (`approvable`, `inContext`) use type:'' — jsonapi-resources resolves them to
// the concrete record type on the wire, so no abstract target resource is
// required (same shape tas-approvable already ships).
const ApprovableSchema = withDefaults({
  type: 'approvable',
  fields: [
    { kind: 'attribute', name: 'approval' },
    { kind: 'attribute', name: 'state' },
    { kind: 'attribute', name: 'transitionLog' },
    { kind: 'attribute', name: 'affirmed' },
    { kind: 'attribute', name: 'currentReviewers' },
    { kind: 'attribute', name: 'possibleReviewers' },
    { kind: 'attribute', name: 'createdAt' },
    { kind: 'attribute', name: 'updatedAt' },
    { kind: 'attribute', name: 'createdBy' },
    { kind: 'attribute', name: 'updatedBy' },
    { kind: 'attribute', name: 'dataState' },
    { kind: 'attribute', name: 'dataStateLog' },
    { kind: 'attribute', name: 'deletedAt' },
    {
      kind: 'belongsTo',
      name: 'approvable',
      type: '',
      options: { async: false, inverse: null, polymorphic: true },
    },
    {
      kind: 'belongsTo',
      name: 'inContext',
      type: '',
      options: { async: false, inverse: null, polymorphic: true },
    },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: { async: false, inverse: null },
    },
    { kind: 'belongsTo', name: 'person', type: 'person', options: { async: false, inverse: null } },
  ],
});

export default ApprovableSchema;
